import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M52.3072 21.1529L32.8689 47.7658C32.8349 47.8123 32.8051 47.8616 32.7796 47.9132L30.0361 53.4755C29.8985 53.7543 29.8985 54.0813 30.0361 54.3602L32.5428 59.4424C32.7112 59.7838 33.0589 60 33.4397 60H78.1242C78.9244 60 79.4005 59.107 78.9545 58.4427L53.945 21.1854C53.5582 20.6092 52.7165 20.5925 52.3072 21.1529Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.2069 36.4281L1.16038 58.4102C0.678028 59.071 1.14998 59.9998 1.96808 59.9998H28.2097C28.9507 59.9998 29.4343 59.222 29.1065 58.5574L27.0361 54.36C26.8986 54.0811 26.8986 53.7541 27.0361 53.4752L29.5072 48.4654C29.6937 48.0874 29.6231 47.6331 29.3308 47.3294L18.7349 36.3242C18.3039 35.8765 17.5733 35.9262 17.2069 36.4281Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30.209 33.6201C31.4283 33.6201 32.417 34.6088 32.417 35.8281C32.4168 37.0473 31.4282 38.0352 30.209 38.0352C28.9899 38.035 28.0021 37.0472 28.002 35.8281C28.002 34.6089 28.9898 33.6202 30.209 33.6201ZM30.209 19.9932C31.1006 19.9932 31.8232 20.7168 31.8232 21.6084V29.5049C31.8232 30.3965 31.1006 31.1201 30.209 31.1201C29.3175 31.12 28.5947 30.3964 28.5947 29.5049V21.6084C28.5947 20.7169 29.3175 19.9933 30.209 19.9932Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }